import { Box, Flex, HStack, MixpanelEventSource, MixpanelSourceContext } from '@talos/kyoko';
import { AppBreadcrumbs } from './AppBreadcrumbs';
import { HeaderButtons } from './HeaderButtons';
import { PowerSearchButton } from './PowerSearchButton';
import { HeaderWrapper } from './styles';

export const Header = () => {
  return (
    <MixpanelSourceContext.Provider value={MixpanelEventSource.Header}>
      <InternalHeader />
    </MixpanelSourceContext.Provider>
  );
};

const InternalHeader = () => {
  return (
    <HeaderWrapper>
      <HStack justifyContent="flex-start" flex="1 1 0" overflow="hidden">
        <Box pl="spacing8" overflow="hidden">
          <AppBreadcrumbs />
        </Box>
      </HStack>
      <PowerSearchButton />
      <Flex flex="1 0 0" justifyContent="flex-end">
        <HeaderButtons />
      </Flex>
    </HeaderWrapper>
  );
};
